import { render, staticRenderFns } from "./navigateUserBack.vue?vue&type=template&id=26f81cc0&scoped=true"
import script from "./navigateUserBack.vue?vue&type=script&lang=js"
export * from "./navigateUserBack.vue?vue&type=script&lang=js"
import style0 from "./navigateUserBack.vue?vue&type=style&index=0&id=26f81cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f81cc0",
  null
  
)

export default component.exports